import { render, staticRenderFns } from "./monopoly.vue?vue&type=template&id=34701aac&scoped=true&"
import script from "./monopoly.vue?vue&type=script&lang=js&"
export * from "./monopoly.vue?vue&type=script&lang=js&"
import style0 from "./monopoly.vue?vue&type=style&index=0&id=34701aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34701aac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34701aac')) {
      api.createRecord('34701aac', component.options)
    } else {
      api.reload('34701aac', component.options)
    }
    module.hot.accept("./monopoly.vue?vue&type=template&id=34701aac&scoped=true&", function () {
      api.rerender('34701aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/monopoly.vue"
export default component.exports